export default __webpack_public_path__ + "static/media/fruity_pebbles.5c3bb36b.png";